/**
 * The QuoteElement class is used to manipulate
 * quote elements like <blockquote> and <q>
 */
export class QuoteElement {
    private static instance: QuoteElement;

    /**
     * The private constructor
     * prevents direct instantiation
     */
    private constructor() {
        const quoteElements = this.quoteElements;

        this.prependQuoteIcon(quoteElements);
    }

    /**
     * Method to instantiate the
     * blockquote on the current page
     *
     * @returns {QuoteElement}
     */
    public static use(): QuoteElement {
        if (!QuoteElement.instance) {
            QuoteElement.instance = new QuoteElement();
        }
        return QuoteElement.instance;
    }

    /**
     * Selects the quote elements
     *
     * @returns {NodeListOf<HTMLQuoteElement>}
     */
    protected get quoteElements(): NodeListOf<HTMLQuoteElement> {
        return document.querySelectorAll(".text blockquote, .text q");
    }

    /**
     * Method to prepend a quote icon to quote elements
     *
     * @param {NodeListOf<HTMLQuoteElement>} elements
     * @returns {void}
     */
    private prependQuoteIcon(elements: NodeListOf<HTMLQuoteElement>): void {
        elements.forEach((element) => {
            element.innerHTML = `<svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                class="icon"
            >
                <path d="M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5" />
                <path d="M19 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5" />
            </svg>${element.innerHTML.trim()}`;
        });
    }
}
